'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const utils = require('../utils.js');
const index = require('../numbers/index.js');
const units = require('../numbers/units.js');
const utils$1 = require('./utils.js');

var hsla = {
  test: utils$1.isColorString('hsl', 'hue'),
  parse: utils$1.splitColor('hue', 'saturation', 'lightness'),
  transform: function (_a) {
    var hue = _a.hue,
      saturation = _a.saturation,
      lightness = _a.lightness,
      _b = _a.alpha,
      alpha$1 = _b === void 0 ? 1 : _b;
    return 'hsla(' + Math.round(hue) + ', ' + units.percent.transform(utils.sanitize(saturation)) + ', ' + units.percent.transform(utils.sanitize(lightness)) + ', ' + utils.sanitize(index.alpha.transform(alpha$1)) + ')';
  }
};

exports.hsla = hsla;
